import { Controller } from "stimulus"
import { getCSRFToken } from "../../util";

export default class extends Controller {
  static targets = [
    "amount",
    "body1",
    "body2",
    "tax",
    "errorContainer",
    "errorMsg",
    "paymentGatewayType",
    "planName",
    "submitButton",
    "subscriptionPlanPriceId",
    "subscriptionType",
    "target",
    "title",
  ]

  onClickPaymentButton() {
    $(this.data.get("payment-gateway-modal-id")).modal("hide");
    $(".modal-backdrop").remove(); // https://stackoverflow.com/q/22056147/113573
    $(this.data.get("modal-id")).modal("show");

    this.resetError();
  }

  fetchUpgradeDetails() {
    if (!this.confirmationModalRendered() || this.dataFetchedBefore()) return;

    const path = this.data.get("upgrade-amount-calculator-path");
    const params = [
      `next_subscription_plan_price_id=${this.data.get("subscription-plan-price-id")}`,
      `proration_date=${this.data.get("proration-date")}`,
      `type=${this.data.get("subscription-type")}`,
    ].join("&");

    fetch(`${path}&${params}`)
      .then((res) => res.json())
      .then((res) => {
        this.titleTarget.innerHTML = res.title;
        this.body1Target.innerHTML = res.body_1;
        this.body2Target.innerHTML = res.body_2;
        this.taxTarget.innerHTML = res.tax;
      });
  }

  onConfirm() {
    this.resetError();

    this.submitButtonTarget.disabled = false;
    this.submitButtonTarget.classList.remove("tw-bg-primary-600", "hover:tw-bg-primary-700");

    const upgradePath = this.data.get("upgrade-path");

    fetch(upgradePath, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRFToken()
      },
      method: "POST",
      credentials: "same-origin",
      body: JSON.stringify({
        payment_gateway_type: this.paymentGatewayTypeTarget.value,
        subscription_plan_price_id: this.subscriptionPlanPriceIdTarget.value,
      })
    })
      .then((res) => {
        if (!res.ok) {
          this.showError();

          return;
        }

        return res;
      })
      .then((res) => res.json())
      .then((res) => {
        if (res.type === "card" && res.hasOwnProperty("stripe_session_id")) {
          const stripe = Stripe(this.data.get("stripe-publishable-key"));

          stripe.redirectToCheckout({ sessionId: res.stripe_session_id });
        } else {
          window.location.href = res.redirect_url
        }
      })
  }

  showError() {
    this.errorContainerTarget.classList.remove("tw-hidden");
    this.errorContainerTarget.innerHTML = this.data.get("error-message");
    this.submitButtonTarget.disabled = false;
    this.submitButtonTarget.classList.add("hover:tw-bg-primary-700", "tw-bg-primary-600");
  }

  resetError() {
    this.errorContainerTarget.classList.add("tw-hidden");
    this.errorContainerTarget.innerHTML = "";
  }

  dataFetchedBefore() {
    return (this.titleTarget.innerHTML.trim() !== "");
  }

  confirmationModalRendered() {
    return this.hasTitleTarget;
  }
}
